<template>
  <span
    class="belyashi-egg"
    @click="onClick"
  >{{ text }}</span>
</template>

<script>
import stickerUrl from '@/assets/img/easter-eggs/no-belyashi-sticker.png'

const NEED_CLICKS = 5
const CLICK_WINDOW_MS = 2800
const TOAST_MS = 6500

let toastEl = null
let toastTimer = null

function ensureToastStyles() {
  if (typeof document === 'undefined') return
  let style = document.getElementById('belyashi-egg-toast-style')
  if (!style) {
    style = document.createElement('style')
    style.id = 'belyashi-egg-toast-style'
    document.head.appendChild(style)
  }
  style.textContent = `
    .belyashi-egg-toast {
      position: fixed;
      right: 18px;
      bottom: 20px;
      z-index: 10050;
      width: min(220px, calc(100vw - 36px));
      padding: 10px 10px 12px;
      border-radius: 18px;
      background: rgba(255, 255, 255, 0.96);
      border: 1px solid rgba(102, 204, 102, 0.28);
      box-shadow:
        0 16px 36px rgba(45, 90, 45, 0.16),
        0 4px 10px rgba(0, 0, 0, 0.08);
      color: #2d4a2d;
      font-family: "Circe", sans-serif;
      font-size: 14px;
      line-height: 1.35;
      text-align: center;
      opacity: 0;
      transform: translateY(18px) scale(0.92) rotate(-2deg);
      pointer-events: none;
    }
    .belyashi-egg-toast.is-in {
      animation: belyashiEggIn 0.6s cubic-bezier(0.22, 1, 0.36, 1) forwards;
    }
    .belyashi-egg-toast.is-out {
      animation: belyashiEggOut 0.35s ease-in forwards;
    }
    .belyashi-egg-toast__img {
      display: block;
      width: 100%;
      height: auto;
      border-radius: 12px;
      animation: belyashiEggPop 0.7s 0.05s cubic-bezier(0.22, 1, 0.36, 1) both;
    }
    .belyashi-egg-toast__text {
      display: block;
      margin-top: 8px;
      padding: 0 4px;
      animation: belyashiEggText 0.55s 0.12s cubic-bezier(0.22, 1, 0.36, 1) both;
    }
    @keyframes belyashiEggIn {
      from { opacity: 0; transform: translateY(18px) scale(0.92) rotate(-2deg); }
      to { opacity: 1; transform: translateY(0) scale(1) rotate(0deg); }
    }
    @keyframes belyashiEggOut {
      from { opacity: 1; transform: translateY(0) scale(1) rotate(0deg); }
      to { opacity: 0; transform: translateY(12px) scale(0.94) rotate(1deg); }
    }
    @keyframes belyashiEggPop {
      0% { opacity: 0; transform: scale(0.86); }
      60% { opacity: 1; transform: scale(1.04); }
      100% { opacity: 1; transform: scale(1); }
    }
    @keyframes belyashiEggText {
      from { opacity: 0; transform: translateY(6px); }
      to { opacity: 1; transform: translateY(0); }
    }
    @media (max-width: 640px) {
      .belyashi-egg-toast {
        right: 12px;
        bottom: 14px;
        width: min(200px, calc(100vw - 24px));
      }
    }
  `
}

function showBelyashiToast(message) {
  if (typeof document === 'undefined') return
  ensureToastStyles()
  if (toastTimer) {
    clearTimeout(toastTimer)
    toastTimer = null
  }
  if (toastEl && toastEl.parentNode) {
    toastEl.parentNode.removeChild(toastEl)
  }
  toastEl = document.createElement('div')
  toastEl.className = 'belyashi-egg-toast is-in'
  toastEl.setAttribute('role', 'status')
  const safeMsg = String(message)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
  toastEl.innerHTML =
    `<img class="belyashi-egg-toast__img" src="${stickerUrl}" alt="" width="220" height="220" />` +
    `<span class="belyashi-egg-toast__text">${safeMsg}</span>`
  document.body.appendChild(toastEl)
  toastTimer = setTimeout(() => {
    if (!toastEl) return
    toastEl.classList.remove('is-in')
    toastEl.classList.add('is-out')
    const el = toastEl
    setTimeout(() => {
      if (el && el.parentNode) el.parentNode.removeChild(el)
      if (toastEl === el) toastEl = null
    }, 360)
  }, TOAST_MS)
}

export default {
  name: 'BelyashiEggText',
  props: {
    text: { type: String, required: true },
  },
  data() {
    return {
      clicks: 0,
      resetTimer: null,
    }
  },
  beforeDestroy() {
    if (this.resetTimer) clearTimeout(this.resetTimer)
  },
  methods: {
    onClick() {
      if (this.resetTimer) clearTimeout(this.resetTimer)
      this.clicks += 1
      this.resetTimer = setTimeout(() => {
        this.clicks = 0
      }, CLICK_WINDOW_MS)
      if (this.clicks < NEED_CLICKS) return
      this.clicks = 0
      showBelyashiToast('Ну правда нельзя беляши, что тут не понятного?')
    },
  },
}
</script>

<style scoped>
.belyashi-egg {
  cursor: text;
  text-decoration: none;
  background: none;
  border: 0;
  padding: 0;
  margin: 0;
  font-weight: inherit;
  font-style: inherit;
  letter-spacing: inherit;
}
</style>
